@if (showOtherInput) {
  <div style="display: flex; align-items: flex-end; gap: 10px;">
    <div style="flex: 1;">
      <tidy-input
        [icon]="'assets/svg/create.svg'"
        [label]="label"
        [(ngModel)]="otherValue"
        (ngModelChange)="onOtherInputChange($event)"
        [form]="form"
        [submitted]="submitted"
        [errorMessage]="errorMessage" />
    </div>
    <div style="padding-bottom: 5px;">
      <tidy-text
        class="link"
        [body]="'Change'"
        (action)="showOtherInput = false; selectedValue = ''; parseCurrentValue()" />
    </div>
  </div>
} @else {
  <tidy-select
    [icon]="'assets/svg/list.svg'"
    [label]="label"
    [form]="form"
    [(ngModel)]="selectedValue"
    (ngModelChange)="onSelectionChange($event)"
    [items]="selectItems"
    [selectedItem]="selectedItem"
    [submitted]="submitted"
    [errorMessage]="errorMessage" />
}